import * as React from "react";
import { Button, Progress, notification, message } from "antd";
// import { dispatch, getState } from "@rematch/core";
import { connect } from "react-redux";

// interface IExportExcelProps {
//   // 事件处理
//   handle: any;
// }

interface IExportExcelProcessProcess {
  // 导出进度
  num: any;
  // 导出进程状态 导出进程全局唯一
  status: any;
  // 下载状态
  downloadStatus: any;
  // 下载进度
  downloadNum: any;
  updateExportProcess: any;
  // 导出方法
  exportHandle: any;
  exportContent?: React.ReactNode;
}

// 更新下载进程
const updateDownloadProcess = (nextProps: any, prevState: any) => {
  if (nextProps.downloadStatus === "start") {
    notification.open({
      message: "文件正在下载中",
      key: "ExportProcess",
      duration: null,
      description: (
        <Progress
          percent={parseInt(nextProps.downloadNum)}
          size="default"
          status="active"
        />
      )
    });
  } else if (nextProps.downloadStatus === "end") {
    notification.open({
      message: "下载成功",
      key: "ExportProcess",
      duration: null,
      description: <Progress percent={100} size="default" status="active" />
    });

    setTimeout(() => {
      notification.close("ExportProcess");
    }, 1000);
  }
};

class ExportExcelProcess extends React.Component<
  IExportExcelProcessProcess,
  any
> {
  state = {
    isExport: false,
    msg: "正在导出,完成后将自动下载文件"
  };

  constructor(props: IExportExcelProcessProcess) {
    super(props);
  }

  componentDidMount() {
    // let num = 0;
    // setInterval(() => {
    //   num += 5;
    //   if (num >= 100) {
    //     this.props.updateExportProcess({
    //       num: 100,
    //       status: "success"
    //     });
    //   } else {
    //     this.props.updateExportProcess({
    //       num
    //     });
    //   }
    // }, 1000);
  }

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    updateDownloadProcess(nextProps, prevState);

    if (nextProps.status === "complete" && nextProps.downloadStatus === "") {
      // 显示进度提醒的判断
      notification.open({
        message: prevState.msg,
        key: "ExportProcess",
        duration: null,
        description: (
          <Progress percent={nextProps.num} size="default" status="active" />
        )
      });

      // // 进度达到了100% 关闭通知
      // if (nextProps.num >= 100) {
      //   setTimeout(() => {
      //     notification.close("ExportProcess");
      //   }, 1000);

      //   // 更新导出状态
      //   // return {
      //   //   isExport: false
      //   // };
      // }

      // return {
      //   isExport: false
      // };
    } else if (nextProps.status === "active") {
      // 显示进度提醒的判断
      notification.open({
        message: prevState.msg,
        key: "ExportProcess",
        duration: null,
        description: (
          <Progress percent={nextProps.num} size="default" status="active" />
        )
      });

      // // 进度达到了100% 关闭通知
      // if (nextProps.num >= 100) {
      //   setTimeout(() => {
      //     notification.close("ExportProcess");
      //   }, 1000);

      //   // 更新导出状态
      //   // return {
      //   //   isExport: false
      //   // };
      // }
      //}
    }

    return null;
  }

  // 事件处理回调
  handleCB = () => {
    // if (!this.state.isExport) {
    // 是否有其他进程在进行导出,有：直接退出  success exception active
    if (
      this.props.status === "active" ||
      this.props.downloadStatus === "start"
    ) {
      message.warning("有其它导出任务，请等待");
      return;
    } else {
      // 导出的回调函数
      const isExport = this.props.exportHandle();

      if (isExport) {
        this.setState({
          isExport: true
        });
        this.props.updateExportProcess({
          num: 0,
          status: "active"
        });
      }
    }
    // }
  };

  // showExport = () => {
  //   if (this.props.exportContent) {
  //     return this.props.exportContent;
  //   } else {
  //     return (
  //       <Button type="primary" onClick={this.handleCB}>
  //         导出Excel
  //       </Button>
  //     );
  //   }
  // };

  render() {
    const buttonStyle = {
      backgroundColor: "#2b9fbd",
      borderColor: "#2b9fbd"
    };
    return (
      <Button type="primary" style={buttonStyle} onClick={this.handleCB}>
        导出Excel
      </Button>
    );
  }
}

const mapState = state => ({
  num: state.globalStatus.exportProcess.num,
  status: state.globalStatus.exportProcess.status,
  downloadNum: state.globalStatus.downloadProcess.num,
  downloadStatus: state.globalStatus.downloadProcess.status
});

const mapDispatch = dispatch => {
  return {
    updateExportProcess: dispatch.globalStatus.updateExportProcess
  };
};

export default connect(
  mapState,
  mapDispatch
)(ExportExcelProcess);
